module.exports = __webpack_public_path__ + "img/icon_ht_home_main.241afdde.svg";